import { Trans } from 'react-i18next';
import Button from '../button/button';
import CloseIcon from '../../assets/closeIcon.svg';

interface PhotoReviewProps {
  imageUrl: string;
  onClose: () => void;
  onRetake: () => void;
  onUpload: () => void;
}

const PhotoReview = ({
  imageUrl,
  onClose,
  onRetake,
  onUpload,
}: PhotoReviewProps) => {
  return (
    <div className="flex flex-col h-full fixed inset-0 z-50 bg-[#120000]">
      <Button
        onClick={onClose}
        className="absolute top-1 right-3 flex items-center justify-center text-white z-10 bg-transparent"
      >
        <img
          src={CloseIcon}
          alt="Close"
          className="w-100 h-100"
          height={47}
          width={47}
        />
      </Button>

      <div className="flex justify-between items-center"></div>
      <div className="flex-1 flex flex-col items-center justify-center mt-[3.5rem] mb-6">
        {imageUrl && (
          <img
            src={imageUrl}
            alt="Preview"
            className="max-w-full max-h-[75vh] object-contain rounded-lg"
          />
        )}
      </div>
      <div className="flex gap-4 mb-10 ml-[3.5rem] mr-[3.5rem]">
        <Button
          onClick={onRetake}
          className="flex-1 py-4 rounded-full font-helvetica text-base bg-white border border-gray-300 text-black"
        >
          <Trans i18nKey="onboarding.retake" />
        </Button>
        <Button
          onClick={onUpload}
          className="flex-1 py-4 rounded-full font-helvetica text-base bg-[#AFF21C]  text-black"
        >
          <Trans i18nKey="onboarding.upload" />
        </Button>
      </div>
    </div>
  );
};

export default PhotoReview;
